import { useEffect, useRef } from 'react';
import { Button } from '../ui/button';
import { Eraser } from 'lucide-react';

export const SignatureInput = ({ id, label, value = [], onChange, disabled }) => {
  const canvas = useRef(null), active = useRef(null), current = useRef(value);
  current.current = value;
  const draw = (strokes) => {
    const el = canvas.current;
    if (!el) return;
    const ctx = el.getContext('2d'); ctx.clearRect(0, 0, el.width, el.height);
    ctx.lineWidth = 2; ctx.strokeStyle = '#172536'; ctx.lineCap = 'round';
    strokes.forEach((stroke) => { ctx.beginPath(); stroke.forEach((p, i) => {
      if (i) ctx.lineTo(p.x * el.width, p.y * el.height); else ctx.moveTo(p.x * el.width, p.y * el.height);
    }); ctx.stroke(); });
  };
  useEffect(() => { draw(value); }, [value]);
  const point = (e) => { const r = canvas.current.getBoundingClientRect(); return { x: Math.max(0, Math.min(1, (e.clientX-r.left)/r.width)), y: Math.max(0, Math.min(1, (e.clientY-r.top)/r.height)) }; };
  const end = () => { if (!active.current) return; const next = [...current.current, active.current]; active.current = null; onChange(next); };
  return <div className="min-w-0 space-y-2">
    <div className="flex items-center justify-between gap-2"><span className="text-sm font-medium">{label}</span>
      {!disabled && <Button size="sm" variant="ghost" type="button" data-testid={`${id}-clear`} onClick={() => onChange([])}><Eraser size={14} />Clear</Button>}
    </div>
    <canvas ref={canvas} width={600} height={180} data-testid={id} aria-label={label} className={`block w-full aspect-[10/3] border border-slate-300 rounded bg-white ${disabled ? '' : 'touch-none cursor-crosshair'}`}
      onPointerDown={(e) => { if (disabled || value.length >= 100) return; e.currentTarget.setPointerCapture(e.pointerId); active.current = [point(e)]; }}
      onPointerMove={(e) => { if (!active.current || active.current.length >= 1000) return; active.current.push(point(e)); draw([...current.current, active.current]); }}
      onPointerUp={end} onPointerCancel={end} />
  </div>;
};